import PropTypes from 'prop-types';

import {ROLES_NAMES} from '@/src/app/constants/roles';
import {USER_STATUSES} from '@/src/app/constants/userStatuses';
import {STUDENT_ID_STATUSES} from '@/src/profile/accountSettings/constants/studentIdStatuses';
import AcademicTitleWidget from '@/src/profile/accountSettings/containers/AcademicTitleWidget';
import AddressWidget from '@/src/profile/accountSettings/containers/AddressWidget';

import MyProfileWrapper from '../../common/containers/MyProfileWrapper';
import AccountSettingsWidget from '../containers/AccountSettingsWidget';
import ContentCreatorSignature from '../containers/ContentCreatorSignature';
import PersonalDetailsWidget from '../containers/PersonalDetailsWidget';

const AccountSettingsLayout = ({userData}) => {
  return (
    <MyProfileWrapper>
      <div>
        <PersonalDetailsWidget
          firstName={userData.user.first_name}
          lastName={userData.user.last_name}
          email={userData.user.email}
          userType={userData.user.type}
          university={
            Boolean(userData.educations) &&
            Boolean(userData.educations.length) &&
            userData.educations[0].school
          }
          studentIdStatus={
            userData?.student_profile?.status || STUDENT_ID_STATUSES.EMPTY
          }
          studentIdNumber={userData?.student_profile?.student_identificator}
          country={userData?.profile?.country}
        />
        {userData?.user?.type !== ROLES_NAMES.CLINIC && (
          <AcademicTitleWidget
            prefixedAcademicTitle={userData?.profile?.prefixed_academic_title}
            suffixedAcademicTitle={userData?.profile?.suffixed_academic_title}
          />
        )}
        {userData?.user?.type !== ROLES_NAMES.CLINIC && <AddressWidget />}
        {userData?.user?.type === ROLES_NAMES.COURSE_CREATOR &&
          userData?.user?.status !== USER_STATUSES.DECLINED &&
          userData?.user?.status !== USER_STATUSES.BLOCKED && (
            <ContentCreatorSignature userData={userData} />
          )}
        <AccountSettingsWidget
          isEmailSubscriptionActive={userData?.profile?.is_marketing_subscribe}
          userType={userData.user.type}
        />
      </div>
    </MyProfileWrapper>
  );
};

AccountSettingsLayout.propTypes = {
  userData: PropTypes.object.isRequired,
};

export default AccountSettingsLayout;
